import request from '@/utils/request';

// 根据字典类型获取字典列表 type
export function getDictsType(options) {
  return request({
    url: '/dicts/list?type=' + options,
    method: 'get'
  });
}
// 单个获取协议内容
export function getProtocolOne(id) {
  return request({
    url: '/op/agreementmanages/' + id,
    method: 'get'
  });
}
// 添加
export function getUserProtocolAdd(options) {
  return request({
    url: '/op/agreementmanages/',
    method: 'post',
    data: options
  });
}
// 编辑
export function getUserProtocolEdit(options) {
  return request({
    url: '/op/agreementmanages/' + options.id,
    method: 'post',
    data: options
  });
}

// 获取列表 feedbackType pageNum pageSize
export function getUserProtocolInfos(options) {
  return request({
    url: '/op/agreementmanages/page-list',
    method: 'get',
    params: options
  });
}
// 添加
export function agreementmanagesPublish(options) {
  return request({
    url: '/op/agreementmanages/publish',
    method: 'post',
    data: options
  });
}
// 添加
export function agreementmanagesBatch(options) {
  return request({
    url: '/op/agreementmanages/batch-status',
    method: 'post',
    data: options
  });
}
